import { gql } from '@apollo/client';

export const GET_TMS_WAREHOUSE_OPERATION_SHIP_OUT_TASK_LIST = gql`
    query GetTmsWarehouseOperationShipOutTaskList(
        $warehouseId: Long!
        $searchText: String
    ) {
        getTmsWarehouseOperationShipOutTaskList(
            warehouseId: $warehouseId
            searchText: $searchText
        ) {
            taskId
            taskNumber
            routeType
            businessType
            taskType
            routeName
            departureTime
            isTikTok
            waypointStatusId
            waypointType
            hasUnsealTime
            waypoints {
                id
                waypointId
                waypointStatus
                waypointOrder
                waypointSortingCode
            }
            licensePlate
            trailerNumber
            bolNumber
            planTimeType
            planTime
            planTimeTimezone
            carrierName
            actions
            taskTitle
            unloadingScanSwitch
        }
    }
`;

export const GET_TMS_WAREHOUSE_OPERATION_SHIP_IN_TASK_LIST = gql`
    query GetTmsWarehouseOperationShipInTaskList(
        $warehouseId: Long!
        $searchText: String
    ) {
        getTmsWarehouseOperationShipInTaskList(
            warehouseId: $warehouseId
            searchText: $searchText
        ) {
            taskId
            taskNumber
            routeType
            businessType
            taskType
            routeName
            departureTime
            isTikTok
            waypointStatusId
            waypointType
            hasUnsealTime
            waypoints {
                id
                waypointId
                waypointStatus
                waypointOrder
                waypointSortingCode
            }
            licensePlate
            trailerNumber
            bolNumber
            planTimeType
            planTime
            planTimeTimezone
            hasUploadBol
            hasUnLoadingTime
            carrierName
            actions
            taskTitle
            unloadingScanSwitch
        }
    }
`;

export interface Waypoint {
    id: number;
    waypointId: string;
    waypointStatus: number;
    waypointOrder: number;
    waypointSortingCode?: string;
}

export interface TmsWarehouseOperationTask {
    taskId: string;
    taskNumber?: string;
    routeType: number;
    /** 路线业务类型（与 enums/TmsEnum.ts 中 TmsRouteBusinessType 一致） */
    businessType?: number | null;
    /** 1-常规 2-临时 3-三方任务 */
    taskType?: number | null;
    routeName: string;
    departureTime: string;
    isTikTok: boolean;
    waypointStatusId: number;
    waypointType: number;
    hasUnsealTime: boolean;
    waypoints: Waypoint[];
    licensePlate: string;
    trailerNumber: string;
    bolNumber: string;
    planTimeType: number;
    planTime: string;
    planTimeTimezone: string;
    hasUploadBol?: boolean;
    hasUnLoadingTime?: boolean;
    carrierName?: string | null;
    actions?: string[];
    taskTitle?: string;
    unloadingScanSwitch?: boolean;
}

export interface GetTmsWarehouseOperationShipOutTaskListResponse {
    getTmsWarehouseOperationShipOutTaskList: TmsWarehouseOperationTask[];
}

export interface GetTmsWarehouseOperationShipInTaskListResponse {
    getTmsWarehouseOperationShipInTaskList: TmsWarehouseOperationTask[];
}

export const GET_TMS_LOADING_DETAIL_SUMMARY = gql`
    query GetTmsLoadingDetailSummary(
        $taskId: Long!
        $taskWayPointId: Long!
    ) {
        getTmsLoadingDetailSummary(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
        ) {
            totalParcelQuantity
            totalBagQuantity
            totalContainerQuantity
            taskBusinessType
            taskTaskType
            totalShipmentPlanPlannedQty
            destinationGroups {
                destinationSortingCode
                loadingDetailCount
                parcelQuantity
                bagQuantity
                containerQuantity
                containers {
                    id
                    taskId
                    taskWaypointId
                    containerType
                    containerCount
                    sortingCode
                    destinationSortingCode
                    destinationWarehouseId
                }
            }
        }
    }
`;

export const GET_TMS_TASK_DRIVER_VEHICLE_INFO = gql`
    query GetTmsTaskDriverVehicleInfo($id: ID!) {
        getTmsTaskById(id: $id) {
            id
            driverName
            phoneNumber
            licensePlate
            trailerNumber
        }
    }
`;

export interface GetTmsTaskDriverVehicleInfoResponse {
    getTmsTaskById: {
        id: string;
        driverName?: string | null;
        phoneNumber?: string | null;
        licensePlate?: string | null;
        trailerNumber?: string | null;
    } | null;
}

export const UPDATE_TMS_TASK_HANDOVER_CARRIER_INFO = gql`
    mutation UpdateTmsTaskHandoverCarrierInfo($id: ID!, $input: UpdateTmsTaskHandoverCarrierInfoInput!) {
        updateTmsTaskHandoverCarrierInfo(id: $id, input: $input)
    }
`;

export interface TmsTaskContainerInfoSummary {
    id?: number;
    taskId: number;
    taskWaypointId: number;
    containerType?: number;
    containerCount: number;
    sortingCode?: string;
    destinationSortingCode?: string;
    destinationWarehouseId?: number;
}

export interface TmsLoadingDetailDestinationGroup {
    destinationSortingCode?: string;
    loadingDetailCount: number;
    parcelQuantity: number;
    bagQuantity: number;
    containerQuantity: number;
    containers: TmsTaskContainerInfoSummary[];
}

export interface TmsLoadingDetailSummary {
    totalParcelQuantity: number;
    totalBagQuantity: number;
    totalContainerQuantity: number;
    taskBusinessType?: number | null;
    taskTaskType?: number | null;
    totalShipmentPlanPlannedQty?: number;
    destinationGroups: TmsLoadingDetailDestinationGroup[];
}

export interface GetTmsLoadingDetailSummaryResponse {
    getTmsLoadingDetailSummary: TmsLoadingDetailSummary;
}

export interface TmsUnloadingDetailRow {
    containerType: number | null;
    expectedCount: number;
    actualCount: number;
    sortingCode?: string | null;
}

export interface TmsUnloadingDetailSummary {
    rows: TmsUnloadingDetailRow[];
}

export interface GetTmsUnloadingDetailSummaryResponse {
    getTmsUnloadingDetailSummary: TmsUnloadingDetailSummary;
}

export const GET_TMS_UNLOADING_DETAIL_SUMMARY = gql`
    query GetTmsUnloadingDetailSummary(
        $taskId: Long!
        $taskWayPointId: Long!
    ) {
        getTmsUnloadingDetailSummary(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
        ) {
            rows {
                containerType
                expectedCount
                actualCount
                sortingCode
            }
        }
    }
`;

export interface SaveTmsUnloadingDetailInfoItemInput {
    containerType: number;
    containerCount: number;
    sortingCode?: string | null;
}

export interface SaveTmsUnloadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    items: SaveTmsUnloadingDetailInfoItemInput[];
    bolRemark?: string | null;
    bolPhotosJson?: string[] | null;
}

export const SAVE_TMS_UNLOADING_DETAIL_INFO = gql`
    mutation SaveTmsUnloadingDetailInfo($input: SaveTmsUnloadingDetailInfoInput!) {
        saveTmsUnloadingDetailInfo(input: $input)
    }
`;


export const GET_HAS_TMS_LOADING_DETAIL = gql`
    query HasTmsLoadingDetail(
        $taskId: Long!
        $taskWayPointId: Long!
    ) {
        hasTmsLoadingDetail(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
        )
    }
`;

export interface HasTmsLoadingDetailResponse {
    hasTmsLoadingDetail: boolean;
}

export const GET_NEEDS_TMS_UNLOADING_OPERATION = gql`
    query NeedsTmsUnloadingOperation(
        $taskId: Long!
        $taskWayPointId: Long!
    ) {
        needsTmsUnloadingOperation(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
        )
    }
`;

export interface NeedsTmsUnloadingOperationResponse {
    needsTmsUnloadingOperation: boolean;
}


export interface SaveTmsLoadingDetailInfoItemInput {
    sortingCode?: string | null;
    destinationWarehouseId?: number | null;
    containerType?: number | null;
    containerCount: number;
}

export interface SaveTmsLoadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    items: SaveTmsLoadingDetailInfoItemInput[];
    loadingInfoRemark?: string | null;
    loadingInfoInteriorPhotosJson?: string[] | null;
    loadingLocalTime?: string | null;
}

export const SAVE_TMS_LOADING_DETAIL_INFO = gql`
    mutation SaveTmsLoadingDetailInfo($input: SaveTmsLoadingDetailInfoInput!) {
        saveTmsLoadingDetailInfo(input: $input)
    }
`;

export const GET_TMS_TASK_WAYPOINT_LOADING_INFO = gql`
    query GetTmsTaskWaypointLoadingInfo($id: ID!) {
        getTmsTaskWaypointById(id: $id) {
            id
            loadingInfoRemark
            loadingInfoInteriorPhotosJson
            loadingInfoInteriorPhotosUrlsJson
        }
    }
`;

export interface GetTmsTaskWaypointLoadingInfoResponse {
    getTmsTaskWaypointById: {
        id: string;
        loadingInfoRemark?: string | null;
        loadingInfoInteriorPhotosJson?: string[] | null;
        loadingInfoInteriorPhotosUrlsJson?: string[] | null;
    } | null;
}

export const UPDATE_TMS_TASK_WAYPOINT_LOADING_INFO = gql`
    mutation UpdateTmsTaskWaypointLoadingInfo(
        $tmsTaskWaypointId: Long!
        $loadingInfoRemark: String
        $loadingInfoInteriorPhotosJson: [String]
    ) {
        updateTmsTaskWaypointLoadingInfo(
            tmsTaskWaypointId: $tmsTaskWaypointId
            loadingInfoRemark: $loadingInfoRemark
            loadingInfoInteriorPhotosJson: $loadingInfoInteriorPhotosJson
        )
    }
`;

export const GET_TMS_UNLOADING_INFO_SUMMARY = gql`
    query GetTmsUnloadingInfoSummary(
        $taskId: Long!
        $taskWayPointId: Long!
    ) {
        getTmsUnloadingInfoSummary(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
        ) {
            destinationSortingCodes
            expectedBagCount
            actualBagCount
            unloadedBagCount
            actualParcelQuantity
            containerTypeRows {
                containerType
                expectedCount
            }
            destinationGroups {
                sortingCode
                expectedBagCount
                actualBagCount
                containerRows {
                    containerType
                    expectedCount
                }
            }
        }
    }
`;

export interface TmsUnloadingInfoContainerRow {
    containerType: number;
    expectedCount: number;
}

export interface TmsUnloadingInfoDestinationGroup {
    sortingCode: string;
    expectedBagCount: number;
    actualBagCount: number;
    containerRows: TmsUnloadingInfoContainerRow[];
}

export interface TmsUnloadingInfoSummary {
    destinationSortingCodes: string[];
    expectedBagCount: number;
    actualBagCount: number;
    unloadedBagCount: number;
    actualParcelQuantity: number;
    containerTypeRows: TmsUnloadingInfoContainerRow[];
    destinationGroups: TmsUnloadingInfoDestinationGroup[];
}

export interface GetTmsUnloadingInfoSummaryResponse {
    getTmsUnloadingInfoSummary: TmsUnloadingInfoSummary;
}

export const GET_TMS_UNLOADING_BAG_DETAIL = gql`
    query GetTmsUnloadingBagDetail(
        $taskId: Long!
        $taskWayPointId: Long!
        $detailType: Int!
    ) {
        getTmsUnloadingBagDetail(
            taskId: $taskId
            taskWayPointId: $taskWayPointId
            detailType: $detailType
        ) {
            totalBagCount
            totalParcelCount
            items {
                bagNumber
                trackingNumber
                displayNumber
                destinationSortingCode
                parcelQuantity
                unloadingStatus
            }
        }
    }
`;

export interface TmsUnloadingBagDetailItem {
    bagNumber?: string | null;
    trackingNumber?: string | null;
    displayNumber?: string | null;
    destinationSortingCode?: string | null;
    parcelQuantity: number;
    unloadingStatus: number; // 0=未卸车 1=已卸车
}

export interface TmsUnloadingBagDetail {
    totalBagCount: number;
    totalParcelCount: number;
    items: TmsUnloadingBagDetailItem[];
}

export interface GetTmsUnloadingBagDetailResponse {
    getTmsUnloadingBagDetail: TmsUnloadingBagDetail;
}

export const GET_TMS_TASK_WAYPOINT_BOL_INFO = gql`
    query GetTmsTaskWaypointBolInfo($id: ID!) {
        getTmsTaskWaypointById(id: $id) {
            id
            bolRemark
            bolPhotosJson
            bolPhotosUrlsJson
        }
    }
`;

export interface GetTmsTaskWaypointBolInfoResponse {
    getTmsTaskWaypointById: {
        id: string;
        bolRemark?: string | null;
        bolPhotosJson?: string[] | null;
        bolPhotosUrlsJson?: string[] | null;
    } | null;
}

// 干线卸车保存（公共逻辑 + 包牌已卸标记）；新版PDA干线卸车使用
export const SAVE_UNLOADING_DETAIL_INFO = gql`
    mutation SaveUnloadingDetailInfo($input: SaveUnloadingDetailInfoInput!) {
        saveUnloadingDetailInfo(input: $input)
    }
`;

export interface SaveUnloadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    bolRemark?: string | null;
    bolPhotosJson?: string[] | null;
    unloadingLocalTime?: string | null;
    operationSource?: number | null;
    addedBagNumbers?: string[];
    addedTrackingNumbers?: string[];
    removedBagNumbers?: string[];
    removedTrackingNumbers?: string[];
}

